const getArrayDepth = (arr) => (Array.isArray((arr))
  ? 1 + Math.max(0, ...(arr).map(getArrayDepth))
  : 0);

export default getArrayDepth;
